export interface MaskDefinition {
    [key: string]: string;
}

export const defaultMaskDefinition: MaskDefinition = {
    '9': '[0-9]',
    x: '[A-Za-z]',
    '*': '[A-Za-z0-9]',
};

export const applyMaskToString = ({
    value,
    mask,
    maskDefinition = defaultMaskDefinition,
}: {
    value?: string;
    mask?: string;
    maskDefinition?: MaskDefinition;
}): string => {
    if (!mask || !value) return value ?? '';

    let formattedString = '';
    let valueIndex = 0;

    for (let maskIndex = 0; maskIndex < mask.length && valueIndex < value.length; maskIndex++) {
        const maskChar = mask[maskIndex];
        const valueChar = value[valueIndex];
        const maskPattern = maskDefinition[maskChar.toLowerCase()];

        if (maskPattern) {
            const regex = new RegExp(maskPattern);
            if (regex.test(valueChar)) {
                const isUpperCaseMaskChar = /[A-Z]/.test(maskChar);
                formattedString += isUpperCaseMaskChar ? valueChar.toUpperCase() : valueChar;
                valueIndex++;
            } else {
                break;
            }
        } else {
            formattedString += maskChar;
            if (valueChar.toLowerCase() === maskChar.toLowerCase()) {
                valueIndex++;
            }
        }
    }

    return formattedString;
};
